import { clearListViewVirtualization } from 'owa-mail-list-store';
import { createLazyOrchestrator } from 'owa-bundling';
import {
    setShowListPane,
    setShowReadingPane,
    onClientReadingPanePositionChange,
} from 'owa-mail-layout';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';
import { shouldShowReadingPane } from 'owa-mail-layout/lib/selectors/shouldShowReadingPane';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';

/**
 * Clears the vlv-rowInfo from list view store upon reading pane position change
 * and determines whether to show/hide reading pane and list view
 */

export const onClientReadingPanePositionChangeOrchestrator = createLazyOrchestrator(
    onClientReadingPanePositionChange,
    'CLONE_CLIENT_READING_PANE_POSITION_CHANGE',
    actionMessage => {
        const tableView = getSelectedTableView();
        const isReadingPaneOff = isReadingPanePositionOff();

        /**
         * Continue showing reading pane if a single item was selected
         * and reading pane position is OFF
         */
        const showReadingPane = isReadingPaneOff
            ? shouldShowReadingPane() && tableView?.selectedRowKeys?.size == 1
            : true;

        /**
         * If RP position is OFF, hide/show LV depending on RP
         * else always show LV
         */
        const showListView = isReadingPaneOff ? !showReadingPane : true;

        setShowReadingPane(showReadingPane /* showReadingPane */);
        setShowListPane(showListView /* showListPane */);

        clearListViewVirtualization(false /* isNewTableLoad */);
    }
);
